export const convertUnits = bytes => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i;

  for (i = 0; bytes >= 1024 && i < 4; i++) {
    bytes /= 1024;
  }

  return bytes.toFixed(2) + units[i];
};
